import useGetRequestBody from "../../useGetRequestBody";
import { getAssetTypes } from "../../../requests/type-requests";
import {useMemo} from "react";
import {SnackbarShowMessage} from "../../../context/snackbar-context";

export interface IAssetType {
  value: string;
  key: string;
}

/**
 * Returns a list of all currently logged-in user's locations with an empty string id and 'All' location name
 * @param showMessage - function to show messages from the api response, optional
 * @returns {IAssetType[]}
 */
const useAssetTypes = (showMessage?: SnackbarShowMessage): IAssetType[] => {
  const allAssetTypes: IAssetType[] = useGetRequestBody(getAssetTypes, useMemo(() => [], []), showMessage);
  return useMemo(() => allAssetTypes, [allAssetTypes]);
};

export default useAssetTypes;
